import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import {InfoOutlined} from "@material-ui/icons";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        '& svg': {
            marginRight: theme.spacing()
        }
    }
}));

export default function DescriptionText(props) {
    const {
        children,
        icon = false
    } = props;
    const classes = useStyles();

    return (
        <Typography variant="body1" className={classes.root}>
            {icon && (
                <InfoOutlined fontSize="small" />
            )}
            <span>{children}</span>
        </Typography>
    );
};

DescriptionText.propTypes = {
    icon: PropTypes.bool
};